/**
 * @generated SignedSource<<e1ddb3f3ecec047a1f699c6642db7748>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchGraphProject_AtlassianSearchPage$data = {
  readonly entity?: {
    readonly status?: string | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphProject_AtlassianSearchPage";
};
export type searchGraphProject_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphProject_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphProject_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isprojectrendererenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphProject_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "condition": "__relay_internal__pv__isprojectrendererenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "status"
                }
              ],
              "type": "ExternalProject"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};

(node as any).hash = "1351b8c888a78a13ca4510226d47ec15";

export default node;
